import * as React from 'react';
import { useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { PricePlanFormView } from '../PricePlanEditForm/view';
import { PRICE_PLAN_CREATE } from 'const/mutations';
import { APP_QUERY } from 'const/queries';

export function PricePlanCreateForm() {
    const navigate = useNavigate();
    const { id: appId } = useParams<{ id: string }>();

    const { data } = useQuery(APP_QUERY, { variables: { id: appId } });
    const app = data && data.app;

    const plan = useMemo(
        () => ({
            id: '',
            appId: appId,
            name: '',
            type: '',
            monthlyAmount: 0,
            yearlyAmount: 0,
            discountedYearlyPrice: false,
        }),
        [appId]
    );

    const [planCreate, { loading }] = useMutation(PRICE_PLAN_CREATE, {
        onCompleted() {
            navigate('/extranet/apps/' + appId + '/dashboard');
        },
    });

    const onSubmit = (values, form, callback) => {
        values.appId = appId;
        planCreate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate('/extranet/apps/' + appId + '/dashboard');
    };

    return (
        <PricePlanFormView
            app={app}
            plan={plan}
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
        />
    );
}
